import { createStore, combineReducers } from 'redux';
import { configureStore } from '@reduxjs/toolkit';

import cmsReducer from './Reducers/cmsReducer';
import uploadsReducer from './redux/slices/uploadsSlice';

export const store = configureStore({
  reducer: {
    uploads: uploadsReducer,
    cms: cmsReducer,
    // Add other reducers here
  },
});